export class ErrorResponseV3 {
  constructor() { };
  public status: number;
  public message: string;
  public code: string;
}
export class ResponseV3 {
  constructor() { this.error = new ErrorResponseV3(); };
  public id: number;
  public messageId: string;
  public error: ErrorResponseV3;
  public code: string;
  public message: string;
}
export class BaseListV3 extends ResponseV3 {
  constructor() { super(); };
  public name: string;
  public totalBlacklisted: number;
  public totalSubscribers: number;
  public folderId: number;
}
export class ListListsV3 extends ResponseV3 {
  constructor() {
    super();
    this.lists = [];
  };
  public count: number;
  public lists: Array<BaseListV3>;
}
